import { ConnectWalletModal } from "../../../../components";
import KycPrevent from "./components/KycPrevent/KycPrevent";
import LoginWithTfa from "./components/LoginWithTfa/LoginWithTfa";
import { MissingKyc } from "./components/MissingKyc/MissingKyc";
import NoExtension from "./components/NoExtension/NoExtension";
import SwitchAccountAuth from "./components/SwitchAccountAuth/SwitchAccountAuth";
import SwitchNetwork from "./components/SwitchNetwork/SwitchNetwork";
import TfaForActionModal from "./components/TfaForActionModal/TfaForActionModal";

const ConnectWalletAssets = () => (
  <>
    <ConnectWalletModal />
    <NoExtension />
    <SwitchNetwork />
    <SwitchAccountAuth />
    <LoginWithTfa />
    <KycPrevent />
    <TfaForActionModal />
    <MissingKyc />
  </>
);

export default ConnectWalletAssets;
